import styled from 'styled-components'
import { themeGet } from 'styled-system'
import { ContainedButton, SearchSelect } from 'secondstep-components'

export const EstimatedTime = styled.span`
  font-size: 1rem;
  font-family: ${themeGet('font.molde.regular')};
  font-style: italic;
  color: ${themeGet('colors.darkGray')};
`

export const Image = styled.img`
  width: 75px;
  height: 75px;
`

export const GetStartedButton = styled(ContainedButton).attrs(
  ({ dataTestId }) => ({
    'data-testid': dataTestId,
  }),
)`
  min-width: 123px;
  flex: none;
`

export const PageContent = styled.div.attrs(({ dataTestId }) => ({
  'data-testid': dataTestId,
}))`
  display: flex;
  align-items: center;
  padding: 1.25rem;
  border: 2px solid ${themeGet('colors.paleGray')};
  border-radius: 0.625rem;

  #step-icon {
    min-width: 75px;
    min-height: 75px;
  }
`

export const PageNavigator = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 1.688rem 3.75rem 2.375rem;
  align-items: center;
  box-sizing: border-box;
`

export const PlaybookStepsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  background: ${themeGet('colors.white')};
  border-radius: 0.5rem;
  padding: 0.875rem 1.25rem 1.75rem;

  ${themeGet('breakpoints.medium')} {
    max-width: 100%;
  }
`

export const RightContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const StepDropdown = styled(SearchSelect)`
  margin-bottom: 0.5rem;

  #playbook-steps-dropdown-button {
    border: none;
    padding-left: 0;

    span:first-of-type {
      color: ${themeGet('colors.darkBlue')};
      font-size: 1.4375rem;
      font-family: ${themeGet('font.sharpSlab.semibold')};
    }

    svg:first-of-type {
      margin-top: 0.1875rem;
      width: 19px;
      height: 11px;
      color: ${themeGet('colors.blue')};
    }
  }

  [class*='DropdownSpaceFiller'] {
    display: none;
  }

  [class*='DropdownOptions'] {
    width: auto;
    padding: 0;
    border-radius: 0.625rem;
    box-shadow: 0 0 12px rgba(0, 40, 85, 0.4);
    margin-top: 0;
    border: none;

    [class*='DropdownOption-sc'] {
      padding-left: 0.875rem;
      padding-bottom: 0.125rem;
      padding-right: 1rem;
      border-bottom: 1px solid ${themeGet('colors.paleGray')};

      &:first-of-type {
        padding-top: 0.25rem;
      }

      &:last-of-type {
        border-bottom: none;
      }
    }
  }
`

export const StepNumber = styled.span`
  font-size: 0.75rem;
  letter-spacing: 1.6px;
  font-family: ${themeGet('font.molde.regular')};
  color: ${themeGet('colors.gray1100')};
`

export const StyledHr = styled.hr`
  height: 2px;
  width: 100%;
  border: none;
  background-color: ${themeGet('colors.blueGrayLight')};
`

export const StyledLinkDropdown = styled(SearchSelect)`
  margin-bottom: 0.5rem;

  svg {
    color: ${themeGet('colors.darkBlue')};

    &:last-of-type {
      width: 14px;
      height: 12px;
      margin-left: auto;
      color: ${themeGet('colors.white')};
    }
  }

  span {
    color: ${themeGet('colors.darkBlue')};
    font-family: ${themeGet('fontFamilySemibold')};
  }

  [class*='LabelWrapper'] {
    display: none;
  }

  [class*='DropdownButton'] {
    background: ${themeGet('colors.blue')};
    border: unset;
    border-radius: 15px;
    height: 31px;

    span {
      color: ${themeGet('colors.white')};
    }

    svg:first-of-type {
      color: ${themeGet('colors.white')};
      width: 25px;
      height: 17px;
      padding-right: 0.375rem;
    }

    ${themeGet('breakpoints.tablet')} {
      width: 12rem;
    }
  }

  [class*='DropdownOptions'] {
    border: none;
    border-radius: 0.3125rem;
    box-shadow: 0 0 22px rgba(0, 0, 0, 0.2);
    margin-top: 0.625rem;
    padding: 0.25rem 0;
    width: 18rem;

    button {
      padding: 0.125rem 1rem;

      svg {
        padding-left: 0.5rem;
      }
    }

    button:not(:last-child) {
      border-bottom: solid 1px ${themeGet('colors.paleGray')};
    }

    @media screen and (max-width: 1050px) {
      right: 0;
    }

    ${themeGet('breakpoints.tablet')} {
      right: unset;
    }
  }

  [class*='DropdownSpaceFiller'] {
    display: none;
  }

  ${themeGet('breakpoints.tablet')} {
    padding-left: 0;
  }
`

export const SubTitle = styled.span`
  line-height: 1.25rem;
`

export const SummaryLink = styled.a`
  color: ${themeGet('colors.blue')};
  font-size: 1rem;
  font-family: ${themeGet('font.molde.medium')};
  text-decoration: none;
  cursor: pointer;
  white-space: nowrap;
  transition: color 0.2s ease;

  &:hover {
    color: ${themeGet('colors.darkBlue')};
    transition: color 0.2s ease;
  }
`

export const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 1.25rem;
  width: 100%;
`

export const Title = styled.span`
  margin-bottom: 0.125rem;
  font-size: 1rem;
  font-family: ${themeGet('font.sharpSlab.semibold')};
  color: ${themeGet('colors.darkBlue')};
`

export const TopWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 1.25rem;
  border-bottom: 2px solid ${themeGet('colors.paleGray')};
`
